














import Component from 'vue-class-component';
import Vue from 'vue';

@Component({})
class Notification extends Vue {
}

export default Notification;
